module.exports = __webpack_public_path__ + "static/media/Agenda1.717d4789.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/Agenda/Agenda1.png
// module id = 1966
// module chunks = 0